var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"col-12 text-left"},[_c('router-link',{attrs:{"to":{ name: 'TagsDashboard', }}},[_c('button',{staticClass:"btn mx-1 rounded-pill btn-primary"},[_vm._v("تگ ها")])])],1),_c('tag-form',{attrs:{"submit-function":_vm.updateTag,"mode":"update"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }